/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_cognito_identity_pool_id": "us-west-1:e4dafd93-40a0-4c25-aece-2f421debab7c",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_o4kEPkQqA",
    "aws_user_pools_web_client_id": "7orjsueoit0ea904571n3lfirv",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "inboardclient102025-main",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;
